import Icon, { IconName } from "components/ui/Icon";
import { Eyebrow } from "components/ui/Text";
import React from "react";
import styled from "styled-components";

const Item = styled.div`
  display: flex;
  gap: 12px;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;

  border-radius: 9999px;
  background: ${(props) => props.theme.colors.secondary}44;
`;

const ItemContent = styled.div`
  display: grid;
  gap: 2px;
`;

const ItemHeading = styled(Eyebrow)`
  color: ${(props) => props.theme.colors.primary};

  font-size: ${(props) => props.theme.fontSizes.xxs}px;
`;

const ItemBody = styled.div`
  display: grid;
  gap: 4px;
`;

export interface InfoListItem {
  icon: IconName;
  label: string;
  value: string;
}

interface Props {
  items: InfoListItem[];
}

const BankAccount: React.FC<Props> = ({ items }) =>
  items.map((item) => (
    <Item key={item.label}>
      <IconWrapper>
        <Icon name={item.icon} color="primary" />
      </IconWrapper>
      <ItemContent>
        <ItemHeading>{item.label}</ItemHeading>
        <ItemBody>{item.value}</ItemBody>
      </ItemContent>
    </Item>
  ));

export default BankAccount;
